import { Injectable } from '@angular/core';

import { StorageManager } from 'src/app/common/storage-manager.class';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { CueBaseRequest, CueSendRequest, CueSyncRequest } from 'src/app/models/fincas/cue.model';

/** Builds the backend payloads required by the CUE export flow. */
@Injectable({ providedIn: 'root' })
export class CueExportPayloadBuilder {
  public buildStatusRequest(finca: FincasModel): CueBaseRequest {
    return {
      id_finca: finca.id,
      id_usuario: StorageManager.getUser().id
    };
  }

  public buildSendRequest(finca: FincasModel): CueSendRequest {
    return {
      ...this.buildStatusRequest(finca),
      codigo_REA: finca.codigo_REA ?? '',
      comunidad_autonoma_ine: finca.comunidad_autonoma_INE ?? '',
      nif: finca.nif ?? ''
    };
  }

  public buildSyncRequest(finca: FincasModel, petitionCode: string): CueSyncRequest {
    return {
      ...this.buildSendRequest(finca),
      codigo_peticion: petitionCode
    };
  }
}
